const RTL_LETTER = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
const LTR_LETTER = /[A-Za-z\u00C0-\u02FF\u1E00-\u1EFF]/;

export function textDir(value) {
  for (const char of String(value || '')) {
    if (RTL_LETTER.test(char)) return 'rtl';
    if (LTR_LETTER.test(char)) return 'ltr';
  }
  return '';
}

export function foldText(value) {
  return String(value)
    .toLocaleLowerCase('en')
    .replace(/[\u064B-\u0652\u0670\u0640]/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي');
}

export function matchFolded(text, query) {
  const foldedQuery = foldText(query);
  if (!foldedQuery) return null;
  const chars = [];
  const map = [];
  const source = String(text);
  for (let index = 0; index < source.length; index += 1) {
    const folded = foldText(source[index]);
    for (const char of folded) {
      chars.push(char);
      map.push(index);
    }
  }
  const found = chars.join('').indexOf(foldedQuery);
  if (found < 0) return null;
  return [map[found], map[found + foldedQuery.length - 1] + 1];
}
